<template>
  <div class="productos-factura">
    <div class="productos-factura__rotulo">Productos de la factura</div>
    <p class="productos-factura__texto">
      Toca un producto para añadirlo a la nota con la cantidad que aún se puede devolver; después la puedes ajustar.
      Puedes hacer varias notas sobre la misma factura: solo se ofrece lo que las notas anteriores no han devuelto ya.
    </p>
    <div v-if="disponibles.length > 0" class="productos-factura__fichas">
      <button
        v-for="itemDocument in disponibles"
        :key="itemDocument.id"
        :id="'item-invoice-' + itemDocument.id"
        type="button"
        class="productos-factura__ficha"
        @click="selectItem(itemDocument)"
      >
        <v-icon x-small class="mr-1">mdi-plus</v-icon>
        <span>{{ itemDocument.product.name }}<template v-if="itemDocument.product_variant && itemDocument.product_variant.name"> - {{ itemDocument.product_variant.name }}</template></span>
        <small class="productos-factura__disponible">Disponible para devolver: {{ itemDocument.quantity_available }}</small>
      </button>
    </div>
    <p v-else-if="!item || !item.invoice" class="productos-factura__vacio">Elige primero la factura: aquí aparecerán sus productos.</p>
    <p v-else class="productos-factura__vacio">Ya añadiste todos los productos que se pueden notar de la factura.</p>
  </div>
</template>
<style scoped>
.productos-factura {
  margin: 12px 16px;
  padding: 12px 14px;
  border: 1px dashed rgba(0, 0, 0, 0.25);
  border-radius: 6px;
}
.productos-factura__rotulo {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #5f6368;
}
.productos-factura__texto {
  margin: 6px 0 10px;
  font-size: 13px;
  color: #3c4043;
}
.productos-factura__fichas {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.productos-factura__ficha {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  font-size: 13px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 999px;
  cursor: pointer;
}
.productos-factura__ficha:hover {
  border-color: #24a9e1;
  color: #24a9e1;
}
.productos-factura__disponible {
  margin-left: 6px;
  color: #5f6368;
  font-size: 11px;
}
.productos-factura__vacio {
  margin: 0;
  font-size: 13px;
  color: #5f6368;
}
</style>
<script>
import { nuevoId } from '@/plugins/unique-id';
import BaseFormPage from "@/components/mixins/BaseFormPage";
import MixinFormActions from "@/components/mixins/MixinFormActions";
import MixinModalDynamic from "@/components/mixins/MixinModalDynamic";
import NextMixinListPage from "@/components/mixins/NextMixinListPage";
import MixinActions from "@/components/mixins/MixinListActions";
//import MixinUtilSdCreditNote from "./MixinUtilSdCreditNote";
//import SdCreditNoteUpdate from "./SdCreditNoteUpdate";

export default {
  mixins: [NextMixinListPage, MixinActions],
  components: {},
  props: ["item", "itemsCreditNote", "openModalProductsInvoice"],
  data() {
    return {
      title: "Proveedores",
      form: {},
      url: "api/v1/provider-basic",
      pathBase: "/purchase/provider",
      options: {
        page: 1,
        itemsPerPage: 10,
        itemsPerPageOptions: [10, 25, 50, 100],
      },
      detailsSelected: [],
      productsInvoice: [],
    };
  },
  computed: {
    // Sólo se ofrece lo que todavía se puede devolver.
    disponibles() {
      return this.productsInvoice.filter((p) => p.quantity_available > 0);
    },
  },
  watch: {
    openModalProductsInvoice: {
      deep: true,
      handler() {
        if (this.openModalProductsInvoice) {
          this.getProductsInvoice();
        }
      },
    },
    itemsCreditNote(val){
      this.getProductsInvoice();

    }
  },
  mounted() {
    this.getProductsInvoice();
  },
  methods: {
    closeModalModifyCreditNote() {
      this.productsInvoice = [];
      this.$emit("modal:close");
    },
    getProductsInvoice() {
      if (typeof this.item.invoice !== "undefined") {
        this.productsInvoice = [];
        this.$http
          .get(
            (this.item.electronica
              ? "api/v1/invoice-products-availables/"
              : "api/v1/invoice-products-availables-for-de-credit-note/") +
              this.item.invoice.id,
            null,
            true,
            true
          )
          .then((response) => {
            if (response.success) {
              for(let it of response.items){
                it._editing = false;
                if(it._id){
                  it.id = it._id;
                  delete it._id;
                }
                if(!it.id){
                    it.id = nuevoId();
                }
              }
              this.removeExistingDetail(response.items, this.itemsCreditNote);
            }
          });
      } else {
        this.productsInvoice = [];
      }
    },
    removeExistingDetail(itemsInvoice, itemsCreditNote) {
      for (const itemDt of itemsInvoice) {
        this.productsInvoice.push(itemDt);
      }

      if (itemsCreditNote.length > 0) {
        for (const itemCN of itemsCreditNote) {
          let resultIndex = this.productsInvoice.findIndex(
            (obj) => obj.id === itemCN.id
          );
          if (resultIndex !== -1) {
            this.productsInvoice.splice(resultIndex, 1);
          }
        }
      }
    },
    selectItem(item) {
      if(item.quantity_available <= 0){
        alert("De este producto/servicio ya se devolvierón todas las existencias disponibles, no es posible agregar.");
      }else{
        this.productsInvoice = [];
        item.quantity = item.quantity_available;
        item._editing = true;
        item.is_new = true;
        item.reverse_inventory = { id: "false", name: "No" };

        if (item.taxes && item.taxes.length > 0) {
          item.tax =  item.taxes[0];
        } else {
          item.tax = {
            id: 3,
            name: "Sin Impuesto",
            base: "100",
            percentage: "0",
            type: "IVA",
            tax_amount: 0
          };
        }
        
        item.rule = { id: 20076022, name: "Devoluciones en ventas" };
        const subtotal = (item.quantity * parseFloat(item.item_amount)) - (item.tax.tax_amount); 
        if(typeof item.line_extension_amount === "undefined") {
          item.line_extension_amount = subtotal;
        }        
        if(typeof item.subtotal_amount === "undefined") {
          item.subtotal_amount = subtotal;
        }
        if(typeof item.total_amount === "undefined") {
          item.total_amount = subtotal;
        }   
        
        if(item.tax && typeof item.tax.taxable_amount == undefined) {
          item.tax.taxable_amount = item.subtotal_amount;
        }   
        
        if (item.product) {
          if (item.product.unity && item.product.unity.id) {
            item.product.inv_unity_id = item.product.unity.id;
          }
        } 

        if (item.allowance_charges && item.allowance_charges.length > 0) {
          if(item.allowance_charges[0] == null){
            item.allowance_charges[0] = {
              charge_indicator: false,
              allowance_charge_reason: "DESCUENTO GENERAL",
              amount: 0,
              base_amount: item.line_extension_amount,
            }
          } else {
            if(typeof item.allowance_charges[0].base_amount == 'undefined') {
              item.allowance_charges[0].base_amount = item.line_extension_amount;
            }
            if(typeof item.allowance_charges[0].charge_indicator == 'undefined') {
              item.allowance_charges[0].charge_indicator = false;
            }
            if(typeof item.allowance_charges[0].allowance_charge_reason == 'undefined') {          
              item.allowance_charges[0].allowance_charge_reason = "DESCUENTO GENERAL";
            }    
            if(typeof item.allowance_charges[0].amount == 'undefined') {          
              item.allowance_charges[0].amount = 0;
            }             
          }                   
        }        
        this.$emit("modal:detailSend", item);
      }
    },
    getColorStatus(itemDocument){
      if(itemDocument.products_refund < itemDocument.quantity){
        return 'green';
      }
      else if(itemDocument.products_refund >= itemDocument.quantity){
        return 'red';
      }
    }
  },
};
</script>
